import { CalculationListEmptyState } from "features/calculation/CalculationListEmptyState";
import { CalculationListTable } from "features/calculation/CalculationListTable";
import { useTransactionCalculationAndFeeBasisListSuspense } from "gen/endpoints/transactions/transactions";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PageInstructions } from "shared/components/layout/PageInstructions";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const FundFamilySetupFundTabCalculations: React.FC = () => {
  const { t } = useTranslation(["calculation"]);
  const navigate = useNavigate();

  const { fundFamilyId } = useRequiredStringParams();

  const { data } =
    useTransactionCalculationAndFeeBasisListSuspense(fundFamilyId);

  const onClickAddCalculation = () => {
    navigate("create");
  };

  return (
    <PageTabBody>
      <PageInstructions>{t("calculation:description")}</PageInstructions>
      {data.rows.length ? (
        <CalculationListTable
          fundFamilyId={fundFamilyId}
          onClickAddCalculation={onClickAddCalculation}
        />
      ) : (
        <CalculationListEmptyState
          onClickAddCalculation={onClickAddCalculation}
        />
      )}
    </PageTabBody>
  );
};
